import moment from 'moment';
import { Sensor } from './api';

export enum CaptureScheduleModalActionTypes {
  CAPTURE_SCHEDULE_MODAL_RESET = 'CAPTURE_SCHEDULE_MODAL_RESET',
  CAPTURE_SCHEDULE_MODAL_SET_PAGE = 'CAPTURE_SCHEDULE_MODAL_SET_PAGE',

  CAPTURE_SCHEDULE_MODAL_CHANGE_DURATION_TYPE = 'CAPTURE_SCHEDULE_MODAL_CHANGE_DURATION_TYPE',
  CAPTURE_SCHEDULE_MODAL_CHANGE_DURATION_VALUE = 'CAPTURE_SCHEDULE_MODAL_CHANGE_DURATION_VALUE',
  CAPTURE_SCHEDULE_MODAL_CHANGE_CAPTURE_DURATION = 'CAPTURE_SCHEDULE_MODAL_CHANGE_CAPTURE_DURATION',
  CAPTURE_SCHEDULE_MODAL_CHANGE_CAPTURES_PER_SCHEDULE = 'CAPTURE_SCHEDULE_MODAL_CHANGE_CAPTURES_PER_SCHEDULE',

  CAPTURE_SCHEDULE_MODAL_WORKING_SCHEDULE_CHANGE_TIME = 'CAPTURE_SCHEDULE_MODAL_WORKING_SCHEDULE_CHANGE_TIME',
  CAPTURE_SCHEDULE_MODAL_WORKING_SCHEDULE_CHANGE_DAYS_OF_WEEK = 'CAPTURE_SCHEDULE_MODAL_WORKING_SCHEDULE_CHANGE_DAYS_OF_WEEK',
  CAPTURE_SCHEDULE_MODAL_WORKING_SCHEDULE_CHANGE_NUMBER_EVENT_RETRIES = 'CAPTURE_SCHEDULE_MODAL_WORKING_SCHEDULE_CHANGE_NUMBER_EVENT_RETRIES',
  CAPTURE_SCHEDULE_MODAL_ADD_CAPTURE_SCHEDULE = 'CAPTURE_SCHEDULE_MODAL_ADD_CAPTURE_SCHEDULE',
  CAPTURE_SCHEDULE_MODAL_REMOVE_CAPTURE_SCHEDULE = 'CAPTURE_SCHEDULE_MODAL_REMOVE_CAPTURE_SCHEDULE',
  CAPTURE_SCHEDULE_MODAL_QUICK_MF = 'CAPTURE_SCHEDULE_MODAL_QUICK_MF',

  CAPTURE_SCHEDULE_MODAL_SET_FINAL_REQUEST_STATUS = 'CAPTURE_SCHEDULE_MODAL_SET_FINAL_REQUEST_STATUS',
}

export type CaptureScheduleModalAction =
  | { type: CaptureScheduleModalActionTypes.CAPTURE_SCHEDULE_MODAL_RESET }
  | {
      type: CaptureScheduleModalActionTypes.CAPTURE_SCHEDULE_MODAL_SET_PAGE;
      page: Page;
    }
  | {
      type: CaptureScheduleModalActionTypes.CAPTURE_SCHEDULE_MODAL_CHANGE_DURATION_TYPE;
      durationType: Duration;
    }
  | {
      type: CaptureScheduleModalActionTypes.CAPTURE_SCHEDULE_MODAL_CHANGE_DURATION_VALUE;
      value: string | moment.Moment;
    }
  | {
      type: CaptureScheduleModalActionTypes.CAPTURE_SCHEDULE_MODAL_CHANGE_CAPTURE_DURATION;
      captureDuration: string;
    }
  | {
      type: CaptureScheduleModalActionTypes.CAPTURE_SCHEDULE_MODAL_CHANGE_CAPTURES_PER_SCHEDULE;
      capturesPerSchedule: string;
    }
  | {
      type: CaptureScheduleModalActionTypes.CAPTURE_SCHEDULE_MODAL_WORKING_SCHEDULE_CHANGE_TIME;
      time: string;
    }
  | {
      type: CaptureScheduleModalActionTypes.CAPTURE_SCHEDULE_MODAL_WORKING_SCHEDULE_CHANGE_DAYS_OF_WEEK;
      daysOfWeek: Array<DaysOfWeek>;
    }
  | {
      type: CaptureScheduleModalActionTypes.CAPTURE_SCHEDULE_MODAL_WORKING_SCHEDULE_CHANGE_NUMBER_EVENT_RETRIES;
      numberOfEventRetries: string;
    }
  | {
      type: CaptureScheduleModalActionTypes.CAPTURE_SCHEDULE_MODAL_ADD_CAPTURE_SCHEDULE;
    }
  | {
      type: CaptureScheduleModalActionTypes.CAPTURE_SCHEDULE_MODAL_REMOVE_CAPTURE_SCHEDULE;
      index: number;
    }
  | {
      type: CaptureScheduleModalActionTypes.CAPTURE_SCHEDULE_MODAL_QUICK_MF;
      time: string;
      daysOfWeek: Array<DaysOfWeek>;
      numberOfEventRetries: number;
    }
  | {
      type: CaptureScheduleModalActionTypes.CAPTURE_SCHEDULE_MODAL_SET_FINAL_REQUEST_STATUS;
      status: Status;
      error?: any;
    };

export enum Page {
  GLOBAL_CONFIGURATION = 'GLOBAL_CONFIGURATION',
  CAPTURE_SCHEDULES = 'CAPTURE_SCHEDULES',
  SUMMARY = 'SUMMARY',
  PROCESSING = 'PROCESSING',
}

export const PAGES_IN_ORDER = [
  Page.CAPTURE_SCHEDULES,
  Page.GLOBAL_CONFIGURATION,
  Page.SUMMARY,
  Page.PROCESSING,
];

export enum Status {
  IDLE = 'idle',
  LOADING = 'loading',
  COMPLETE = 'complete',
  ERROR = 'error',
}

export enum Duration {
  END_DATE = 'END_DATE',
  TOTAL_CAPTURES = 'TOTAL_CAPTURES',
}

export type DaysOfWeek =
  | 'Monday'
  | 'Tuesday'
  | 'Wednesday'
  | 'Thursday'
  | 'Friday'
  | 'Saturday'
  | 'Sunday';
export const DAYS_OF_WEEK: Array<DaysOfWeek> = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

export type TotalCapturesDuration = {
  type: Duration.TOTAL_CAPTURES;
  value: string; // This is a number, but stored in a string as this is mapped to the input box in the modal
};

export type EndDateDuration = {
  type: Duration.END_DATE;
  value: moment.Moment;
};

export type PartialCaptureSchedule = {
  time: string;
  daysOfWeek: Array<DaysOfWeek>;
  numberOfEventRetries: number;
};

export type CaptureScheduleModalState = {
  status: Status;
  open: boolean;

  page: Page;
  error?: any;

  selectedSensors: Array<{
    serial_number: Sensor['serial_number'];
    link_id: string;
    name: string;
    organization: {
      id: string;
      name: string;
    };
  }>;

  duration: TotalCapturesDuration | EndDateDuration;
  captureDurationInSeconds: string;
  capturesPerSchedule: string;
  schedules: Array<PartialCaptureSchedule>;
  workingScheduleCopy: {
    time: string;
    daysOfWeek: Array<DaysOfWeek>;
    numberOfEventRetries: string;
  };

  finalRequestStatus: Status;
  finalRequestError: any;
};
